import { FC, useEffect, useState } from "react";

import { useTranslator } from "@/i18n/useTranslator";

import { DsButton, DsModal, DsText, DsTextArea } from "../components/ui";

type DriverCameraAddCommentModalPropsType = {
  isOpen: boolean;
  value: string;
  onDismiss: () => void;
  onAddComment: (comment: string) => void;
};

const DriverCameraAddCommentModal: FC<DriverCameraAddCommentModalPropsType> = ({
  isOpen,
  onAddComment,
  onDismiss,
  value,
}) => {
  const { t } = useTranslator();

  const [comment, setComment] = useState("");

  useEffect(() => {
    setComment(value);
  }, [value]);

  const handleOnAddComment = () => {
    onAddComment(comment);
    setComment(value);
  };

  const handleDismiss = () => {
    onDismiss();
    setComment(value);
  };

  return (
    <DsModal
      shouldApplyFullScreenPadding={false}
      isOpen={isOpen}
      onDismiss={handleDismiss}>
      <div className="w-[325px]">
        <DsText variant="pageTitle" className="text-left">
          {t("driver_camera_component.add_comment")}
        </DsText>
        <DsTextArea
          className="mt-4 mb-3"
          value={comment}
          onChange={e => setComment(e.target.value)}
        />
        <div className="flex flex-row gap-4">
          <DsButton
            onClick={handleDismiss}
            className="inline-flex w-full"
            variant="secondary">
            {t("cancel")}
          </DsButton>
          <DsButton onClick={handleOnAddComment} className="inline-flex w-full">
            {t("driver_camera_component.add")}
          </DsButton>
        </div>
      </div>
    </DsModal>
  );
};

export { DriverCameraAddCommentModal };
